import { Button, Divider, Grid2 as Grid } from "@mui/material";
import { isArray, isEqual } from "lodash";
import { useState } from "react";
import {
  CreateProgramEligibilityQuestionMutationVariables,
  EligibilityQuestionAnswerFormatTypeEnum,
  UpdateProgramEligibilityQuestionMutationVariables as Question,
  useUpdateProgramEligibilityQuestionMutation,
} from "~/graphql/__generated__/graphql";
import QuestionForm, { predicateValid } from "./QuestionForm";
import { gql } from "@apollo/client";

type Props = {
  question: Question & {
    answerFormatType: EligibilityQuestionAnswerFormatTypeEnum
    programEligibilityQuestions: CreateProgramEligibilityQuestionMutationVariables["programEligibilityQuestions"],
  }
}


const EligibilityQuestionFormRow = ({ question }: Props) => {
  const [local, setLocal] = useState(question);

  const addNullIds = (l: CreateProgramEligibilityQuestionMutationVariables): Props["question"] => {
    const answerOptions = isArray(l.answerOptions)
      ? l.answerOptions.map(a => ({ id: null, ...a, __typename: undefined }))
      : l.answerOptions ? [{ id: null, ...l.answerOptions, __typename: undefined }] : null;
    return ({
      ...l,
      id: local.id,
      answerOptions,
    })
  }

  const noLocalChanges = isEqual(local, question);
  const [updateQuestion, { loading }] = useUpdateProgramEligibilityQuestionMutation();

  const onSave = () => {
    const { answerFormatType: _answerFormatType, ...vars } = local;
    updateQuestion({ variables: vars })
  }

  return <Grid container sx={{ alignItems: "center" }} rowSpacing={1}>
    <Grid size={12}>
      <Divider sx={{ mb: 1 }} />
    </Grid>
    <QuestionForm local={local} setLocal={l => setLocal(addNullIds(l))} loading={loading} lockFormat={true} />
    <Grid>
      <Button variant="contained" size="small" color="primary" disabled={noLocalChanges || !predicateValid(local)} onClick={onSave} loading={loading}>
        Save
      </Button>
      <Button
        variant="outlined"
        size="small"
        color="secondary"
        onClick={() => setLocal(question)}
        sx={{ ml: 1 }}
      >
        Reset
      </Button>
    </Grid>
  </Grid>
}

export default EligibilityQuestionFormRow;

gql(`
  mutation UpdateProgramEligibilityQuestion(
    $id: Int!
    $programEligibilityQuestions: [ProgramEligibilityQuestionProgramInput!]!
    $question: String!
    $answerModule: EligibilityQuestionAnswerModuleEnum
    $answerModulePredicate: String
    $answerOptions: [UpdateAnswerOption!]
    $useForPreScoreCheck: Boolean!
  )
  @permission(requires: manageOrgConfig)
  {
    updateProgramEligibilityQuestion(
        id: $id,
        programEligibilityQuestions: $programEligibilityQuestions,
        question: $question,
        answerModule: $answerModule,
        answerModulePredicate: $answerModulePredicate,
        answerOptions: $answerOptions
        useForPreScoreCheck: $useForPreScoreCheck,
    ) {
      id
    }
  }
`);
